// extracted by mini-css-extract-plugin
export default {"predictiveModel":"components_predictiveModel__n6hWA","ItemAdvantages":"components_ItemAdvantages__1o644"};